import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CreateDiscussion_public from './CreateDiscussion_public';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import EditDiscussionModal from './EditDiscussionModal';
import Discussion from './Discussion';
import  usePreloadDiscussions  from "../services/usePreloadDiscussions";
import usePhoneContacts from "../hooks/usePhoneContacts";

const isCordova = typeof window.cordova !== "undefined";

const THEME_ICONS = {
  actualite: "/icons/actualite.svg",
  divertissement: "/icons/divertissement.svg",
  viequotidienne: "/icons/vie-quotidienne.svg",
  vieprofessionnelle: "/icons/vie-professionnelle.svg",
};
const remove_icon = "/icons/user-remove.svg";
const add_icon = "/icons/user-add.svg";
const edit_icon = "/icons/edit.svg";

export default function PublicGroups({ user, socket, prompt, userObj, setCallInProgress, selectedDiscussion, setSelectedDiscussion }) {
  const [search, setSearch] = useState("");
  const [discussions, setDiscussions] = useState([]);
  const [discussion, setDiscussion] = useState([]);
  const { t } = useTranslation();
const [setIsMember] = useState(false);
const [preloadedMessages, setPreloadedMessages] = useState({});
	//const [loadingDiscussions, setLoadingDiscussions] = useState(false);
const { messagesCache, setMessagesCache, loading: loadingPreload } = usePreloadDiscussions(discussions);

  const [loading, setLoading] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const navigate = useNavigate();
const [showForm, setShowForm] = useState(false);
const phoneContacts = usePhoneContacts();

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const token = localStorage.getItem('token') || "";
const [loadingDiscussions, setLoadingDiscussions] = useState(false);
const [selectedInfoDiscussion, setSelectedInfoDiscussion] = useState(null);
const [editModal, setEditModal] = useState(null);
const THEME_KEYS = [
  "actualite",
  "divertissement",
  "viequotidienne",
  "vieprofessionnelle"
];


const navigateToProfile = (creatorId) => {
    navigate(`/profile/${creatorId}`);
  };
const formatDate = (isoDate, language = 'fr') => {
  const date = new Date(isoDate);

  const locales = {
    fr: 'fr-FR',
    en: 'en-US',
    de: 'de-DE',
    es: 'es-ES',
    pt: 'pt-PT',
    it: 'it-IT',
    hu: 'hu-HU',
    ua: 'uk-UA',
    sv: 'sv-SE',
    nl: 'nl-NL',
    fi: 'fi-FI',
    pl: 'pl-PL',
    ro: 'ro-RO',
    el: 'el-GR',
    no: 'no-NO',
    da: 'da-DK',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    hr: 'hr-HR',
    lt: 'lt-LT',
    et: 'et-EE',
    lv: 'lv-LV',
    bg: 'bg-BG',
    sl: 'sl-SI',
    sr: 'sr-RS'

    
    // Ajoute d'autres langues ici si besoin
  };

  const locale = locales[language] || 'fr-FR'; // fallback par défaut

  const formattedDate = date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  return formattedDate;
};

const language = i18n.language;


const fetchDiscussions = async () => {
  setLoadingDiscussions(true);

  try {
    const res = await api.post(
      `${API_URL}/api/discussions/public`,
      { theme: selectedTheme, search, contacts: phoneContacts },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setDiscussions(Array.isArray(res.data) ? res.data : []);
  } catch (err) {
    console.error(err);
    setDiscussions([]);
  } finally {
    setLoadingDiscussions(false);
  }
};

  useEffect(() => {
  if (selectedTheme !== null || search !== "")
{

    setLoadingDiscussions(true);

    api.post(
  `${API_URL}/api/discussions/public`,  
  { theme: selectedTheme, search, contacts: phoneContacts },  
  { headers: { Authorization: `Bearer ${token}` } }  
)
      .then((res) => {
        // ✅ s'assure que res.data est un tableau
        setDiscussions(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error(err);
        setDiscussions([]); // éviter undefined
      })
      .finally(() => setLoadingDiscussions(false));
  }
}, [selectedTheme, search]);


useEffect(() => {
  
 fetchDiscussions();
}, [selectedTheme, search, phoneContacts]);


const handleDiscussionCreated = (newDiscussion) => {
    setDiscussions((prev) => [...prev, newDiscussion]);
    setShowForm(false);
// ⚡ Notifier les autres utilisateurs
    socket.emit("user_create_discussion", {
      newDiscussion,
      userId: user._id
    });

  };

//fonction pour supprimer une discussion

const handleDiscussionDeleted = async (discussionId) => {
const { alert, confirm} = prompt;


  const confirmation = await confirm(t('discussion.alertdeletediscussion'));

  if (confirmation) {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`${API_URL}/api/discussions/${discussionId}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
// ➕ Notifie les autres utilisateurs via le socket
socket.emit("user_delete_discussion", {
      discussionId,
      userId: user._id
    });

       

    setDiscussions(prev => prev.filter(d => d._id !== discussionId));
  if (selectedDiscussion && selectedDiscussion._id === discussionId) {
    setSelectedDiscussion(null);
  }
  const { alert, confirm} = prompt;
      await alert(t('discussion.deletediscussionsucces'));
    } catch (error) {
      console.error('Erreur lors de la suppression de la discussion', error);
      await alert(t('discussion.deletediscussionerror'));
    }
  }
};

  const handleJoin = async (discussionId) => {


  const { alert, confirm } = prompt;

  if (!(await confirm(t('diffusion.alertinscription')))) return;

  try {
    await api.post(
      `${API_URL}/api/discussions/${discussionId}/join`,
      {},
      { headers: { Authorization: `Bearer ${user?.token}` } }
    );

    // ⚡ Notifier les autres utilisateurs
    socket.emit("user_joined_discussion", {
      discussionId,
      userId: user._id
    });


    // 🔄 mettre à jour la liste pour l'utilisateur actuel
    setDiscussions(prev =>
      prev.map(d =>
        d._id === discussionId
          ? { ...d, participants: [...d.participants, user._id] }
          : d
      )
    );

    // 🔄 mettre à jour la discussion en fullscreen
    setSelectedDiscussion(prev =>
      prev && prev._id === discussionId
        ? { ...prev, participants: [...prev.participants, user._id] }
        : prev
    );

    await alert(t('diffusion.inscriptionsucces'));

  } catch (err) {
    console.error(err);
    alert("Erreur lors de l'inscription");
  }
};



const handleLeave = async (discussionId) => {
  const { alert, confirm } = prompt;

  if (!(await confirm(t('diffusion.alertdesinscription')))) return;

  try {
    await api.post(
      `${API_URL}/api/discussions/${discussionId}/leave`,
      {},
      { headers: { Authorization: `Bearer ${user?.token}` } }
    );
// ⚡ Notifier les autres utilisateurs
    socket.emit("user_left_discussion", {
      discussionId,
      userId: user._id
    });

    // 🔄 mettre à jour la liste
    setDiscussions(prev =>
      prev.map(d =>
        d._id === discussionId
          ? { ...d, participants: d.participants.filter(p => p !== user._id) }
          : d
      )
    );

    // 🔄 mettre à jour la discussion en fullscreen
    setSelectedDiscussion(prev =>
      prev && prev._id === discussionId
        ? {
            ...prev,
            participants: prev.participants.filter(p => p !== user._id)
          }
        : prev
    );

    await alert(t('diffusion.desinscriptionsucces'));

  } catch (err) {
    console.error("Erreur désinscription :", err);
  }
};

//affichage des modifs en direct
useEffect(() => {
  if (!socket) return;


// 🟢 Lorsqu'une diffusion est créée
	const handleDiscussionCreated = ({ newDiscussion }) => {
    
    setDiscussions(prev => [...prev, newDiscussion]);
  };
// 🟢 Lorsqu'une diffusion est supprimée
const handleDeleted = ({ discussionId }) => {
    setDiscussions((prev) => prev.filter((d) => d._id !== discussionId));
    if (selectedDiscussion && selectedDiscussion._id === discussionId) {
      setSelectedDiscussion(null);
    }
  };

// 🟢 Lorsqu'une diffusion est modifiée
const handleUpdate = ({ updatedDiscussion }) => {
    const id = updatedDiscussion._id;

    setDiscussions(prev =>
      prev.map(d => d._id === id ? { ...d, ...updatedDiscussion } : d)
    );

    setSelectedDiscussion(prev =>
      prev && prev._id === id
        ? { ...prev, ...updatedDiscussion }
        : prev
    );
  };

  // 🟢 Lorsqu'un utilisateur s'inscrit
  const handleJoin = ({ discussionId, userId }) => {
   

    // Mise à jour liste des discussions
    setDiscussions(prev =>
      prev.map(d =>
        d._id === discussionId
          ? { ...d, participants: [...d.participants, userId] }
          : d
      )
    );

    // Mise à jour si on est dans la discussion fullscreen
    setSelectedDiscussion(prev =>
      prev && prev._id === discussionId
        ? { ...prev, participants: [...prev.participants, userId] }
        : prev
    );
  };

  // 🔴 Lorsqu'un utilisateur se désinscrit
  const handleLeave = ({ discussionId, userId }) => {
    

    setDiscussions(prev =>
      prev.map(d =>
        d._id === discussionId
          ? {
              ...d,
              participants: d.participants.filter(p => String(p) !== String(userId)),
            }
          : d
      )
    );

    setSelectedDiscussion(prev =>
      prev && prev._id === discussionId
        ? {
            ...prev,
            participants: prev.participants.filter(
              p => String(p) !== String(userId)
            ),
          }
        : prev
    );
  };

  // 🎧 Abonnements
  socket.on("user_create_discussion", handleDiscussionCreated);
  socket.on('user_delete_discussion', handleDeleted);
  socket.on("user_update_discussion", handleUpdate);
  socket.on("user_joined_discussion", handleJoin);
  socket.on("user_left_discussion", handleLeave);

  // 🧹 Cleanup
  return () => {
    socket.off("user_create_discussion", handleDiscussionCreated);
    socket.off('user_delete_discussion', handleDeleted);
    socket.off("user_update_discussion", handleUpdate);
    socket.off("user_joined_discussion", handleJoin);
    socket.off("user_left_discussion", handleLeave);
  };
}, [socket]);



function DiscussionInfoModal({ discussion, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{discussion.title}</h2>

        <div className="profile-card" style={{ boxSizing: 'border-box' }}>
          <label><strong>{t('diffusion.description')}</strong></label>
          <p>{discussion.description || "Aucune description"}</p>
        </div>

        <div className="profile-card" style={{ boxSizing: 'border-box' }}>
          <label><strong>{t('diffusion.date_create')}</strong></label>
          <p>{new Date(discussion.createdAt).toLocaleDateString()}</p>
        </div>

        <div className="profile-card" style={{ boxSizing: 'border-box' }}>
          <label><strong>{t('diffusion.abonnes')}</strong></label>
          <p>{discussion.participants?.length || 0}</p>
        </div>

        <button className="modal-close-btn" onClick={onClose}>
          {t('diffusion.close')}
        </button>
      </div>
    </div>
  );
}

const [editDiscussion, setEditDiscussion] = useState(null);
// 🖱️ Gestion de la sélection
useEffect(() => {
  if (!selectedDiscussion) return;

  const updated = discussions.find(d => d._id === selectedDiscussion._id);
  if (updated && updated !== selectedDiscussion) {
    setSelectedDiscussion(updated);
  }

}, [discussions, selectedDiscussion]);

const handleSelectDiscussion = (discussion) => {
  const enriched = {
    ...discussion,
    description: discussion.description,
    isCreator: discussion.creator?._id === userObj._id,
    isMember: Boolean(
      discussion.participants?.some(p => String(p._id || p) === String(userObj._id)) ||
      discussion.subscribers?.some(p => String(p._id || p) === String(userObj._id))
    ),
    // ✅ peut voir le contenu si : creator, member, ou visibility=everyone
    // si visibility=contacts, le fait que la discussion apparaisse dans sa liste
    // signifie déjà que le serveur a validé qu'il est contact
    
  };
  setSelectedDiscussion(enriched);
};


  return (
  <div className="public-groups-container">
  <div className="canal_haut">
    
    <span style={{ display: 'flex', alignItems: 'center', gap:'10px' }}>
      {!showForm ? (
        <button
         
          onClick={() => setShowForm(true)}
	
          className="createpublic text-2xl p-2  text-white rounded-full "
          title="Nouvelle discussion"
        >
          +
        </button>
      ) : (
        <button
	
          onClick={() => setShowForm(false)}
	
          className="createpublic text-2xl p-2  text-white rounded-full "
          title="Masquer le formulaire"
        >
          -
        </button>
      )}
    </span>
<span style= {{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <p className="canal_titre" >{t('diffusion.canal')}</p>
    <span
    className="info-bubble"
    onClick={() => prompt.alert(t('diffusion.info'))}
  >
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


  </span>
</span>
   
    </div>
    {/* Formulaire de création */}
    {showForm && <CreateDiscussion_public onDiscussionCreated={handleDiscussionCreated} />}

    {/* 🔍 Card de recherche */}
<div className="public-search-card">

  {/* Champ de recherche */}
  <div className="search-row search-container">
    <input
      type="text"
      placeholder={t('diffusion.rechercher')}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="search-input"
    />
<span className="search-icon">
    🔍
  </span>
  </div>

  {/* Sélecteur de thèmes */}
  <div className="theme-selector-row icon-select">
  {selectedTheme && (
    <img
      src={THEME_ICONS[selectedTheme]}
      alt=""
      className="theme-select-icon"
    />
  )}
  
  <select
    className="theme-selector"
    value={selectedTheme || ""}
    onChange={(e) => {
      const val = e.target.value;
      setSelectedTheme(val === "" ? null : val);
    }}
  >
    <option value="">— {t('diffusion.allthemes')} —</option>
    {THEME_KEYS.map((themeKey) => (
      <option key={themeKey} value={themeKey}>
        {t(`diffusion.${themeKey}`)}
      </option>
    ))}
  </select>
</div>


</div>


    {/* 💬 Liste des discussions */}
    <div className="list-discussion">
{!selectedDiscussion && (

      <ul className="item_dicussion fade-in">
        {discussions.length === 0 ? (
        loadingDiscussions ? (
          <li className="li_item_dicussion info-message">Chargement...</li>
        ) : (
          <li className="li_item_dicussion info-message">{t('diffusion.listempty')}</li>
        )
      ) : (


        discussions.map((discussion) => (
          <li key={discussion._id} className="discussion-item">

            <div className="left-block">
              <img
                src={
                  discussion.creator?.profileImage
                    ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${discussion.creator._id}?token=${token}&type=image&thumb=true&profile=true&t=${discussion.creator.profileImageUpdatedAt || 0}`
                    : `${API_URL}/uploads/default-profile.png`
                }
                alt="Photo"
                className="discussionImage"
                onClick={(e) => {
                  e.stopPropagation();
                  navigateToProfile(discussion.creator._id);
                }}
                style={{ cursor: 'pointer' }}
              />
              <div className="info-block" onClick={() => handleSelectDiscussion(discussion)}>
                <span className="discussionCreator">{discussion.creator?.username}</span>
                <span className="discussionTitle_public">{discussion.title}</span>
		<span className="themeNom">{t(`diffusion.${discussion.theme}`)}
</span>
                <span className="info-block-members" ><svg  width="20" height="20" viewBox="0 0 24 24" fill="#007bff">
<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0
2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15
14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97
3.45V20h6v-3.5c0-2.33-4.67-3.5-7-3.5z"/>
</svg>
 {discussion.participants?.length || 0}</span>
              </div>
	     


            </div>
            
{
  // sécuriser en cas de données incomplètes
  (() => {
    //const creatorId = String(discussion?.creator?._id || "");
    const userId = String(user?._id || "");
    const participants = discussion.participants || [];

    //const isCreator = creatorId === userId;
const isCreator =
  discussion.creator === userId ||
  discussion.creator?._id === userId;

    const isMember = participants.some(p =>
  String(p._id || p) === userId
);

const isBanned = (discussion.bannedUsers || []).some(b =>
  String(b._id || b) === userId
);


    return (
      <>
        <div className="right-block">
    <>

    {isCreator ? (
<>
<div className="member-actions">
<button style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer' }} onClick={() => setEditModal(discussion)} title="éditer">
<svg width="20" height="20" viewBox="0 0 24 24" fill="#666">
  <path d="M3 21v-3.75L14.81 5.44l3.75 3.75L6.75 21H3zm2.92-2h1.83l9.19-9.19-1.83-1.83L5.92 17.17v1.83zM20.71 7.04l-3.75-3.75 1.79-1.79a1 1 0 011.42 0l2.33 2.33a1 1 0 010 1.42l-1.79 1.79z"/>
</svg>
</button>
<button style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer' }} onClick={() => handleDiscussionDeleted(discussion._id)} title="Supprimer la discussion">
<svg width="20" height="20" viewBox="0 0 24 24" fill="#007bff">
<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1
1H5v2h14V4z"/>
</svg>
</button>


</div>

     </>
    ) : isMember ? (
      <div className="member-actions">
      <span className="member-badge">✔</span>
      <button
      className=""
      style={{ background: 'none' }}
      onClick={() => handleLeave(discussion._id)}
    >
   <img
  src={remove_icon}

  alt="Se désabonner"
  className="leave-svg-icon"
/>


    </button>
     </div>
    ) : (

      <button
  className=""
  style={{ background: 'none' }}
  onClick={() => handleJoin(discussion._id)}
  title="S'abonner"
>
  <img
   src={add_icon}
  alt="S'abonner"
  className="join-svg-icon"
/>

</button>

 

    )}
	<span className="date">{formatDate(discussion.createdAt, language)}</span>
</>
  </div>
      </>

        
      
    );
  })()
}

          </li>
        )))}
      </ul>
)}
{/* Fullscreen Discussion */}
    {selectedDiscussion && (
      <div className={`discussion-fullscreen show`}>
       {/* {messagesCache[selectedDiscussion._id] ? ( */}

          <Discussion
            discussion={selectedDiscussion}
	setDiscussion={setSelectedDiscussion}
            discussionId={selectedDiscussion._id}
	description={selectedDiscussion?.description}
	messages={messagesCache[selectedDiscussion._id] || []}
	selectedDiscussion={selectedDiscussion}
	setSelectedDiscussion={setSelectedDiscussion}
	onDiscussionPublicDeleted={handleDiscussionDeleted}
              setCallInProgress={setCallInProgress}
	handleJoin={handleJoin}
	handleLeave={handleLeave}
          userObj={userObj}
            socket={socket}
            prompt={prompt}
            isPublic={selectedDiscussion.isPublic}
	isCreator={selectedDiscussion.isCreator}
	isMember={selectedDiscussion.isMember}
	visibility={selectedDiscussion.visibility}
	onEdit={(discussion) => setEditModal(discussion)}
	
	          />
       
      </div>
    )}

    </div>
{selectedInfoDiscussion && (
  <DiscussionInfoModal
    discussion={selectedInfoDiscussion}
    onClose={() => setSelectedInfoDiscussion(null)}
  />
)}
{editModal && (
  <EditDiscussionModal
    discussion={editModal}
    onClose={() => setEditModal(null)}
    onUpdated={(updated) => {

   // Notifier les autres
  socket.emit("user_update_discussion", {
    updatedDiscussion: updated
  });

      // ⚡ Fusionne pour ne pas perdre les infos du bloc
      setDiscussions((prev) =>
  prev.map((d) =>
    d._id === updated._id
      ? {
          ...d,
          title: updated.title,
          description: updated.description,
          theme: updated.theme,
	allowComments: updated.allowComments, 
	visibility: updated.visibility,
        }
      : d
  )
);

    }}
  />
)}
  </div>

);

}
